// extracted by mini-css-extract-plugin
export default {"error-text":"Checkbox_error-text__LV6uO","input-disabled":"Checkbox_input-disabled__eY23E"};